#import "../fragments/dashboard-stats-fragment.graphql"

query GetWebsiteTrafficDashboard($input: DashboardInput!) {
    websiteTrafficDashboard(input: $input) {
        stats {
            ...DashboardStatsFragment
        }
    }
}
